import React from 'react'
import UpperContent from './UpperContent'
import LowerContentDesign from './LowerContentDesign'
import UpperContentDesign from './UpperContentDesign'
import LowerContent from './LowerContent'

const style = { display: 'none' }

const PackingSlip = ({
  returnId,
  orderDetails,
}) => (
  <div id="PackingSlip" style={style}>
    <style>{'@media print { * {-webkit-print-color-adjust: exact; color-adjust: exact}'}</style>
    <UpperContentDesign />
    <LowerContentDesign />
    <UpperContent returnId={returnId} orderDetails={orderDetails} />
    <LowerContent />
  </div>
)

export default PackingSlip
